import { type FunctionComponent, type PropsWithChildren } from 'react';
import { type InputSize } from '../input/input.types';
import { inputGroup } from './input-group.css';

export type InputGroupProps = {
	className?: string;
	size?: InputSize;
};

export const InputGroup: FunctionComponent<PropsWithChildren<InputGroupProps>> = ({ className, size = 'DEFAULT', children }) => {
	return (
		<div className={`${inputGroup} ${className ? className : ''} theme-luxury:input-group! ${size.toLocaleLowerCase()}`.trim()}>
			{children}
		</div>
	);
};
